<template>
  <span class="cd-headline rotate-1">
    <span class="cd-words-wrapper">
      <!-- invisible element that always holds the width of the longest word -->
      <b class="cd-sizer">{{ longestSkill }}</b>
      <b
        :class="text == i ? 'is-visible' : 'is-hidden'"
        v-for="(skill, i) in skills"
        :key="i"
      >
        {{ skill }}
      </b>
    </span>
  </span>
</template>

<script>
export default {
  name: `AnimationText`,
  data() {
    return {
      skills: ["Media Buying", "Brand Scaling", "Digital Products", "E-Com", "iGaming", "OFM", "Software Development"],
      text: 0,
    };
  },
  computed: {
    longestSkill() {
      return this.skills.reduce((a, b) => a.length > b.length ? a : b);
    }
  },
  mounted() {
    const interval = setInterval(() => {
      this.text = this.text < this.skills.length - 1 ? this.text + 1 : 0;
    }, 3000);
    return () => clearInterval(interval);
  },
};
</script>

<style scoped>
.cd-words-wrapper {
  text-align: center;
}

.cd-sizer {
  visibility: hidden;
  pointer-events: none;
  position: relative !important;
  white-space: nowrap;
  display: block;
  width: 100%;
}

.cd-headline.rotate-1 b.is-visible,
.cd-headline.rotate-1 b.is-hidden {
  position: absolute !important;
  left: 0;
  right: 0;
  top: 0;
  text-align: center;
}

.cd-headline.rotate-1 b.is-hidden {
  animation: fade-out 0.5s forwards !important;
  transform: none !important;
}

@keyframes fade-out {
  0%   { opacity: 1; }
  100% { opacity: 0; }
}
</style>